import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "CategoryFilterSection-heading" }
const _hoisted_2 = {
  key: 0,
  class: "CategoryFilterSection-icon"
}
const _hoisted_3 = { class: "CategoryFilterSection-title" }
const _hoisted_4 = { class: "CategoryFilterSection-collapsable" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass({'CategoryFilterSection': true, 'is-open': true, 'CategoryFilterSection--productSeries': _ctx.productSeries})
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.attributeSection)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.resolveIconForAttributeSection())))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.section.title), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.section.data, (control, index) => {
        return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.controlType), {
          key: control.name ?? control.nameMin,
          data: control,
          hidden: !_ctx.allVisible && index >= _ctx.visibleCount
        }, null, 8, ["data", "hidden"]))
      }), 128)),
      (_ctx.getHiddenCount())
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "CategoryFilterSection-more",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleVisibility()))
          }, _toDisplayString(_ctx.allVisible ? _ctx.showLessLabel : `${_ctx.showMoreLabel} (${_ctx.getHiddenCount()})`), 1))
        : _createCommentVNode("", true)
    ])
  ], 2))
}